module.exports = __webpack_public_path__ + "static/Ralphs_pin-0f9c8255217a9e1a6a6d0d9fb895d6c1.png";